// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  getDataFromResponse,
  pathologyReportColumns,
} from 'core/diagnostic-report';
import { PaginatedTable } from 'core/table';
import { Section } from 'design-system';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useResponsive } from 'hooks/useResponsive';
import { DiagnosticReportApi } from 'integration';
import type React from 'react';

interface DiagnosticReportListProps {
  patientId: string;
}

const api = new DiagnosticReportApi();

export const ReportTab: React.FC<DiagnosticReportListProps> = ({
  patientId,
}) => {
  const showHeader = useResponsive({ md: true }, false);
  const isStriped = useResponsive({ md: true }, false);

  const fetcher = (options: FetcherOptions) =>
    api.getDiagnosticReports({
      subject: patientId,
      pageToken: options.nextToken,
    });

  const cacheKey = JSON.stringify({
    subject: patientId,
  });

  const columns = pathologyReportColumns(patientId);

  return (
    <Section>
      <PaginatedTable
        cacheKey={`DiagnosticReport${cacheKey}`}
        fetcher={fetcher}
        columns={columns}
        showHeader={showHeader}
        isStriped={isStriped}
        getDataFromResponse={getDataFromResponse}
      />
    </Section>
  );
};
